/** 共用格式化。全站一致，不要各頁自己寫。 */

/** 24 小時制時間。預設的 zh-TW 會輸出「下午 7:19」，在等寬表格裡寬度會跳動。 */
export function fmtTime(s?: string | null): string {
  if (!s) return '—';
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? String(s) : d.toLocaleString('zh-TW', { hour12: false });
}

/** 只要日期。 */
export function fmtDate(s?: string | null): string {
  if (!s) return '—';
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? String(s) : d.toLocaleDateString('zh-TW');
}

/** 位元組轉人看得懂的單位。 */
export function fmtBytes(n?: number | null): string {
  if (n == null) return '—';
  if (n < 1024) return `${n} B`;
  const units = ['KB', 'MB', 'GB', 'TB'];
  let v = n / 1024;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i++;
  }
  return `${v.toFixed(v >= 100 ? 0 : 1)} ${units[i]}`;
}

/** 相對時間，用於「最後心跳」這類欄位。 */
export function fmtAgo(s?: string | null): string {
  if (!s) return '—';
  const t = new Date(s).getTime();
  if (Number.isNaN(t)) return String(s);
  const sec = Math.floor((Date.now() - t) / 1000);
  if (sec < 60) return `${sec} 秒前`;
  if (sec < 3600) return `${Math.floor(sec / 60)} 分鐘前`;
  if (sec < 86400) return `${Math.floor(sec / 3600)} 小時前`;
  return `${Math.floor(sec / 86400)} 天前`;
}

/** 信心值顯示成百分比。 */
export function fmtPct(v?: number | null): string {
  return v == null ? '—' : `${(v * 100).toFixed(1)}%`;
}
